import { createSelector } from "reselect";
import get from "lodash/get";

const appGlobalSettings = state =>
  get(state, "api.appGlobalSettings.data", null);

const rateLimitError = state => get(state, "api.rateLimitError", null);

export const appGlobalSettingsSelector = createSelector(
  appGlobalSettings,
  settings => settings
);

export const makeSelectAppGlobalSettingsSelector = () =>
  appGlobalSettingsSelector;

export const rateLimitErrorSelector = createSelector(
  rateLimitError,
  settings => settings
);

export const makeSelectRateLimitErrorSelector = () => rateLimitErrorSelector;
